import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../../../core/api/queries";

export default createQueryGroup(({ api }) => ({
  visits: (query: {
    from?: string;
    to?: string;
    officeIds?: number[];
    contractTypeIds?: number[];
  }) => {
    return queryOptions({
      queryKey: ["banked_minutes", "visits", query],
      queryFn: () => (api as any).get("./banked_minutes/visits", { query }),
      placeholderData: keepPreviousData,
    });
  },
  jobs: (query: { from: string; to: string }) => {
    return queryOptions({
      queryKey: ["banked_minutes", "jobs", query],
      queryFn: () => (api as any).get("./banked_minutes/jobs", { query }),
      placeholderData: keepPreviousData,
    });
  },
  jobItems: (jobId: number) => {
    return queryOptions({
      queryKey: ["banked_minutes", "jobs", jobId, "items"],
      queryFn: () => (api as any).get("./banked_minutes/jobs/" + jobId + "/items", {}),
      placeholderData: keepPreviousData,
    });
  },
}));
